import { render, staticRenderFns } from "./ChartConfiguration.vue?vue&type=template&id=3b0e3d34"
import script from "./ChartConfiguration.vue?vue&type=script&lang=js"
export * from "./ChartConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0e3d34')) {
      api.createRecord('3b0e3d34', component.options)
    } else {
      api.reload('3b0e3d34', component.options)
    }
    module.hot.accept("./ChartConfiguration.vue?vue&type=template&id=3b0e3d34", function () {
      api.rerender('3b0e3d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceWatcher/ChartConfiguration.vue"
export default component.exports